import { LEGACY_EVENTS } from 'gcs-common/config/googleAnalyticsLegacyConfig';
import { ICON } from 'gcs-common/constants/IconConstants';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import copyToClipboard from 'gcs-common/helper/copyToClipboard';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { trackGALegacyEvent } from 'gcs-common/slices/googleAnalytics/googleAnalyticsThunks';
import { getMyMemberId, getMyPromoEmail, getPromoEmailLoading } from 'gcs-common/slices/members/membersSelectors';
import { createMemberEmail } from 'gcs-common/slices/members/membersThunks/createMemberEmail';
import { fetchMemberEmail } from 'gcs-common/slices/members/membersThunks/fetchMemberEmail';
import { getCurrentUserIsMemberOfChannel } from 'gcs-common/slices/salesSpaceChannels/salesSpaceChannelsSelectors';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../Button/Button';
import PopupMenu from '../../PopupMenu/PopupMenu';

function ChannelEmailPopup() {
  const [showChannelEmailPopup, setShowChannelEmailPopup] = useState(false);
  const selectedChannelId = useSelector(getSelectedChannelId);
  const myMemberId = useSelector(getMyMemberId(selectedChannelId));
  const email = useSelector(getMyPromoEmail(myMemberId));
  const promoEmailLoading = useSelector(getPromoEmailLoading);
  const dispatch = useDispatch();
  const isUserInCurrentChannel = useSelector(getCurrentUserIsMemberOfChannel(selectedChannelId));
  const createEmail = useCallback(async () => {
    dispatch(createMemberEmail({ memberId: myMemberId }));
  }, [myMemberId, dispatch]);

  const onButtonClick = useCallback(() => {
    if (!promoEmailLoading) {
      dispatch(trackGALegacyEvent(LEGACY_EVENTS.DIRECT_MAIL_LINK()));
      if (!email && myMemberId) {
        dispatch(fetchMemberEmail({ memberId: myMemberId }));
      }
      setShowChannelEmailPopup(true);
    }
  }, [dispatch, email, myMemberId, promoEmailLoading]);

  const onOutsideClick = useCallback(() => {
    setShowChannelEmailPopup(false);
  }, []);

  useEffect(() => {
    setShowChannelEmailPopup(false);
  }, [myMemberId]);

  return (
    <div>
      <IconButton
        Icon={ICON.MORE}
        onClick={onButtonClick}
        iconSize="size-6"
        className="cursor-pointer"
        size="m"
        variant="ghost_neutral"
        title="Mehr"
        data-testid="open-channel-email-popup-button"
      />
      <PopupMenu
        isVisible={showChannelEmailPopup && isUserInCurrentChannel}
        onHide={onOutsideClick}
        menuItemsClass="right-[15px]"
      >
        {!email ? (
          <Button type="button" onClick={createEmail} data-testid="create-email-address-button">
            <nobr>Generiere eine Email für Angebote</nobr>
          </Button>
        ) : (
          <>
            <div style={{ border: 'none', padding: '4px 12px', whiteSpace: 'nowrap' }}>
              Email für Angebote aus WW90:
            </div>
            <div style={{ fontWeight: 'bold', padding: '4px 12px', whiteSpace: 'nowrap' }}>{email}</div>
            <Button
              type="button"
              onClick={() => copyToClipboard(email)}
              style={{ width: '100%' }}
              data-testid="copy-email-address-button"
            >
              Kopieren
            </Button>
          </>
        )}
      </PopupMenu>
    </div>
  );
}

ChannelEmailPopup.propTypes = {};

export default ChannelEmailPopup;
